import script from "./TakeSurvey.vue?vue&type=script&setup=true&lang=js"
export * from "./TakeSurvey.vue?vue&type=script&setup=true&lang=js"

import "./TakeSurvey.vue?vue&type=style&index=0&id=cd862c06&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026_previous\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd862c06"]])

export default __exports__